import { TableChangeSource } from '../../../../../common/table/TableTypes';
export const isTableCellMetaChangeSource = (source?: string): boolean =>
    source?.startsWith(`${TableChangeSource.CELL_META_PREFIX}.`) ?? false;
